import type { SvgIconProps } from "@mui/material"
import { SvgIcon } from "@mui/material"

export function ChevronRight(props: SvgIconProps) {
  return (
    <SvgIcon sx={{ width: "8px", height: "14px" }} viewBox="0 0 8 14" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.17192 7.00072L0.221924 2.05072L1.63592 0.636719L7.99992 7.00072L1.63592 13.3647L0.221924 11.9507L5.17192 7.00072Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}
